export const addEventListener = (mediaQuery, handler) => {
  if (mediaQuery?.addEventListener) {
    mediaQuery.addEventListener('change', handler);
  } else {
    // Adding supoport for Safari 14-
    // https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList#browser_compatibility
    mediaQuery.addListener(handler);
  }
};

export const removeEventListener = (mediaQuery, handler) => {
  if (mediaQuery?.removeEventListener) {
    mediaQuery.removeEventListener('change', handler);
  } else {
    mediaQuery.removeListener(handler);
  }
};
